import { createRouter, createWebHistory } from 'vue-router'

// Vistas principales (lazy load para mejor performance)
const HomeView = () => import('../views/HomeView.vue')
const MatMenuView = () => import('../views/MatMenuView.vue')
const CleverLuView = () => import('../views/CleverLuView.vue')
const PrivacyPolicy = () => import('../views/PrivacyPolicy.vue')
const TermsConditions = () => import('../views/TermsConditions.vue')
const CookiesPolicy = () => import('../views/CookiesPolicy.vue')
const NotFound = () => import('../views/NotFound.vue')

// Componente interno (no es vista, se mantiene eager)
import BulkEmailCampaign from '../components/BulkEmailCampaign.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView,
    meta: {
      title: 'LaFuerza IT Chile | Desarrollo de Software Empresarial y SaaS',
      metaTags: [
        { name: 'description', content: 'Empresa chilena de desarrollo de software empresarial, aplicaciones SaaS, migración de datos e infraestructura TI. Partner tecnológico para PYMES y corporaciones en Chile.' },
        { property: 'og:title', content: 'LaFuerza IT Chile — Desarrollo de Software Empresarial y SaaS' },
        { property: 'og:description', content: 'Desarrollo de software personalizado para empresas chilenas. Aplicaciones web, SaaS, migración de datos e infraestructura TI.' },
        { property: 'og:type', content: 'website' }
      ]
    }
  },
  // ⭐ RUTA: MatMenu
  {
    path: '/proyectos/matmenu',
    name: 'MatMenu',
    component: MatMenuView,
    meta: {
      title: 'MatMenu ERP | Proyecto Destacado de LaFuerza IT',
      metaTags: [
        { name: 'description', content: 'Descubre MatMenu, el ERP gastronómico definitivo desarrollado por LaFuerza IT Chile. POS, KDS, Kioscos, Delivery, DTE y más.' },
        { property: 'og:title', content: 'MatMenu ERP | Proyecto Destacado' },
        { property: 'og:description', content: 'El sistema ERP gastronómico todo en uno. Descubre las funcionalidades y planes de MatMenu.' }
      ]
    }
  },
  // ⭐ NUEVA RUTA: CleverLu
  {
    path: '/proyectos/cleverlu',
    name: 'CleverLu',
    component: CleverLuView,
    meta: {
      title: 'CleverLu HealthTech | Software Médico Integral',
      metaTags: [
        { name: 'description', content: 'Descubre CleverLu, el ecosistema SaaS HealthTech de LaFuerza IT para profesionales de la salud. Fichas clínicas, agenda, telemedicina y pagos.' },
        { property: 'og:title', content: 'CleverLu HealthTech | Software Médico Integral' },
        { property: 'og:description', content: 'Digitaliza, automatiza y escala tu gestión clínica con CleverLu. El todo en uno para profesionales de la salud.' },
        { property: 'og:type', content: 'website' }
      ]
    }
  },
  {
    path: '/politica-privacidad',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
    meta: {
      title: 'Política de Privacidad | LaFuerza IT Chile',
      metaTags: [
        { name: 'description', content: 'Política de Privacidad y Protección de Datos Personales de LaFuerza IT Chile según la Ley 19.628.' },
        { name: 'robots', content: 'noindex, follow' }
      ]
    }
  },
  {
    path: '/terminos-condiciones',
    name: 'TermsConditions',
    component: TermsConditions,
    meta: {
      title: 'Términos y Condiciones | LaFuerza IT Chile',
      metaTags: [
        { name: 'description', content: 'Términos y Condiciones de uso de los servicios de LaFuerza IT Chile.' },
        { name: 'robots', content: 'noindex, follow' }
      ]
    }
  },
  {
    path: '/politica-cookies',
    name: 'CookiesPolicy',
    component: CookiesPolicy,
    meta: {
      title: 'Política de Cookies | LaFuerza IT Chile',
      metaTags: [
        { name: 'description', content: 'Política de Cookies de LaFuerza IT Chile. Información sobre las cookies que utilizamos y cómo gestionarlas.' },
        { name: 'robots', content: 'noindex, follow' }
      ]
    }
  },
  {
    path: '/carga',
    name: 'Carga',
    component: BulkEmailCampaign,
    meta: {
      title: 'Carga interna | LaFuerza IT Chile',
      metaTags: [{ name: 'robots', content: 'noindex, nofollow' }]
    }
  },
  // ⚠️ SIEMPRE AL FINAL: catch-all 404
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
    meta: {
      title: 'Página no encontrada | LaFuerza IT Chile',
      metaTags: [{ name: 'robots', content: 'noindex, follow' }]
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return { el: to.hash, behavior: 'smooth', top: 80 }
    if (to.path !== from.path) return { top: 0, behavior: 'smooth' }
  }
})

// =========================================================
// Actualización dinámica de título y meta tags
// =========================================================
const MANAGED = 'data-vue-router-controlled'

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'LaFuerza IT Chile'
  document.querySelectorAll(`meta[${MANAGED}]`).forEach((el) => el.parentNode.removeChild(el))
  if (Array.isArray(to.meta.metaTags)) {
    to.meta.metaTags.forEach((tag) => {
      const meta = document.createElement('meta')
      Object.keys(tag).forEach((key) => meta.setAttribute(key, tag[key]))
      meta.setAttribute(MANAGED, '')
      document.head.appendChild(meta)
    })
  }
  next()
})

export default router